import { Dispatch, SetStateAction } from 'react';
import amplitude from 'amplitude-js';
import axios from 'axios';
import firebase from 'firebase/app';
import * as Sentry from '@sentry/browser';
import { Estudiantes } from 'generated/graphql';

import { authenticate } from 'redux/reducersV2/authAction';
import { resetCurrentDesafioCursoState } from 'redux/reducersV2/currentDesafioCursoStateSlice';
import { TipoUsuarioEnum } from 'enums/tipoUsuario';
import { API_KEY } from '../../../constants';

export const signInPasswordEstudiante = (
	match: Estudiantes[],
	setCustomLoader: Dispatch<SetStateAction<boolean>>,
	dispatch: any,
	onError: () => void
) => {
	dispatch(resetCurrentDesafioCursoState());
	if (match.length > 0) {
		setCustomLoader(true);
		amplitude.getInstance().setUserId(match[0].key || '');
		const identify = new amplitude.Identify()
			.set('uid', match[0].firebase_uid)
			.set('hasuraKey', match[0].key)
			.set('tipoUsuario', 'estudiante')
			.set('nombre', match[0].nombre);

		amplitude.getInstance().identify(identify);

		amplitude.getInstance().logEvent('[ESTUDIANTE] Login', {
			uid: match[0].firebase_uid,
			hasuraKey: match[0].key,
			tipoUsuario: 'estudiante',
			nombre: match[0].nombre
		});
		axios
			.post(`${API_KEY}/auth/signInEstudiante`, {
				login: {
					uid: match[0].firebase_uid,
					hasuraKey: match[0].key,
					tipoUsuario: 'estudiante',
					nombre: match[0].nombre,
					colegio: match[0].colegio?.key,
					avatarPath: match[0].avatarPath,
					rol: match[0].rol
				}
			})
			.then((res) => {
				Sentry.setUser({ hasuraKey: match[0].key, nombre: match[0].nombre, tipo: 'estudiante' });
				firebase
					.auth()
					.signInWithCustomToken(res.data.token)
					.catch((er) => {
						setCustomLoader(false);
						return er;
					})
					.then(() => {
						window.location.replace('/');
						dispatch(authenticate());
					});
			})
			.catch((err) => {
				setCustomLoader(false);
				return err;
			});
	} else {
		setCustomLoader(false);
		onError();
	}
};

export const signInPasswordUserCuenta = (
	match: any[],
	setCustomLoader: Dispatch<SetStateAction<boolean>>,
	dispatch: any,
	onError: () => void,
	tipoUsuario: TipoUsuarioEnum
) => {
	console.log('check,atch', match);
	if (match.length > 0) {
		setCustomLoader(true);
		axios
			.post(
				`${API_KEY}/auth/signInUser`,
				{
					login: {
						uid: match[0].firebase_uid,
						hasuraKey: match[0].key,
						tipoUsuario,
						nombre: match[0].nombre,
						email: match[0].email, // Asegúrate de incluir el email
						colegio: match[0].colegio_key,
						institucion: match[0].institucion_key,
						avatarPath: match[0].avatarPath,
						rol: match[0].rol
					}
				},
				{
					withCredentials: true // Crucial para que las cookies funcionen
				}
			)
			.then((res) => {
				Sentry.setUser({ hasuraKey: match[0].key, nombre: match[0].nombre, tipo: tipoUsuario });
				console.log(res);
				firebase
					.auth()
					.signInWithCustomToken(res.data.token)
					.catch((error: any) => {
						console.log('error', error);
						setCustomLoader(false);
						return error;
					})
					.then(() => {
						localStorage.setItem('key', match[0].key);
						localStorage.setItem('tp', tipoUsuario);
						// window.location.replace('/');

						// eslint-disable-next-line no-restricted-globals
						dispatch(authenticate());
					});
			});
	} else {
		console.log('No match found for user cuenta');
		setCustomLoader(false);
		onError();
	}
};
